export let novemberUppercase = "cDURBd";
export default {novemberUppercase};